@if ($isMeasuring() && !$isMobile()) {
  <div id="measure-popup" class="measure-popup">
    @if ($distance()) {
      <p>{{ 'MAP.TOTALDISTANCE' | translate }} : {{ $distance() }} km</p>
    } @else {
      <p>{{ 'MAP.CLICKONMAP' | translate }}</p>
    }
  </div>
}
